import { render } from "./EmailTransactionPage.vue?vue&type=template&id=8f1b8bc6&scoped=true"
import script from "./EmailTransactionPage.vue?vue&type=script&lang=js"
export * from "./EmailTransactionPage.vue?vue&type=script&lang=js"

import "./EmailTransactionPage.vue?vue&type=style&index=0&id=8f1b8bc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f1b8bc6"]])

export default __exports__